import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import smartImg from "../Assets/smart.jpg";
import electronicsImg from "../Assets/Electronics.avif";
import innovativeImg from "../Assets/innovative.jpg";
import valueImg from "../Assets/value.jpg";
import callImg from "../Assets/call.avif";
//import simImg from "../Assets/sim.jpg";
import  Network  from "../Assets/network.jpg";

const services = [
  { id: 1, name: "Smart Systems", image: smartImg, path: "/smartsystems" },
  { id: 2, name: "Electronics Trading", image: electronicsImg, path: "/electronics-trading" },
  { id: 3, name: "Innovative Intelligence Solutions", image: innovativeImg, path: "/innovative" },
  { id: 4, name: "Gift Cards and Value-added Services", image: valueImg, path: "/Gift&value" },
  { id: 5, name: "Call Centers and Empowerment", image: callImg, path: "/callcenter" },
  { id: 6, name: "Network Services", image: Network, path: "/networking" },
];

const Services = () => {
  const navigate = useNavigate();

  return (
    <div className="pt-20 min-h-screen bg-gradient-to-r from-gray-50 to-gray-100 p-10">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {services.map((service) => (
          <motion.div
            key={service.id}
            className="bg-white rounded-2xl shadow-lg overflow-hidden transform transition duration-300 hover:scale-105"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: service.id * 0.1 }}
          >
            <img
              src={service.image}
              alt={service.name}
              className="w-full h-56 object-cover"
            />
            <div className="p-5 text-center">
              <h3 className="text-2xl font-bold text-black mb-3 font-[Inter]">
                {service.name}
              </h3>
              <button
                onClick={() => navigate(service.path)}
                className="bg-indigo-500 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition-all"
              >
                Know More
              </button>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Services;
